import {
  SpaClassAvialability,
  SpaClassAvialabilityWithSpaClass,
} from '@common/features/spa/spa.types';
import { SpaClass } from '../SpaClasses.types';
export type SpaClassAvialabilityWithClassId = SpaClassAvialability & { classId: number };

export const timeslotToSpaClassMapper = (
  timeslot: SpaClassAvialabilityWithClassId,
  spaClassMap: Map<number, SpaClass>
) => {
  const { classId } = timeslot;
  const spaClass = spaClassMap.get(classId);

  return { ...timeslot, spaClass: spaClass || ({} as SpaClass) };
};

export const groupByTimeslotStartDateTime = (
  timeslots: SpaClassAvialabilityWithClassId[],
  spaClasses: SpaClass[]
) => {
  if (!timeslots) return {};

  const spaClassMap = new Map<number, SpaClass>(spaClasses.map((c) => [c.id, c]));

  return timeslots
    .map((timeslot) => timeslotToSpaClassMapper(timeslot, spaClassMap))
    .reduce(
      (
        acc: Record<string, SpaClassAvialabilityWithSpaClass[]>,
        timeslot: SpaClassAvialabilityWithSpaClass
      ) => {
        const { startDateTime } = timeslot;
        return {
          ...acc,
          [startDateTime]: [...(acc[startDateTime] || []), timeslot],
        };
      },
      {}
    );
};
